var product = "https://shopfront-cdn.tekoapis.com/static/7de71eb80b44de2e.svg";

export { product as default };
